import {
  AUTH_REQUESTING,
  AUTH_LIST_REQUESTING,
  GENERATE_AUTH_REQUESTING,
  SET_TYPE_AUTH_REQUESTING,
  CHANGE_PASS_REQUESTING,
  CHANGE_USER_REQUESTING,
  CHANGE_BANK_REQUESTING,
} from './constants';

export function authRequest(params) {
  console.log(params);
  return {
    type: AUTH_REQUESTING,
    params,
  };
}

export function authListRequest(params) {
  return {
    type: AUTH_LIST_REQUESTING,
    params,
  };
}

export function generateAuthRequest(params) {
  return {
    type: GENERATE_AUTH_REQUESTING,
    params,
  };
}

export function setTypeAuthRequest(params) {
  return {
    type: SET_TYPE_AUTH_REQUESTING,
    params,
  };
}

export function resetAuthRequest(params) {
  return {
    type: 'RESET_AUTH',
  };
}

export function clearAuth() {
  return {
    type: 'CLEAR_AUTH',
  };
}

export function changePassRequest(params) {
  console.log(params);
  return {
    type: CHANGE_PASS_REQUESTING,
    params,
  };
}

export function changeUserRequest(params) {
  console.log(params);
  return {
    type: CHANGE_USER_REQUESTING,
    params,
  };
}

export function changeBankRequest(params) {
  console.log(params);
  return {
    type: CHANGE_BANK_REQUESTING,
    params,
  };
}
